export default __webpack_public_path__ + "static/media/Tether-logo.c4a3ac95.webp";